/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'beach_access': {
    width: 16,
    height: 16,
    viewBox: '0 0 17.996 17.999',
    data: '<path pid="0" d="M10.126 11.559l1.43-1.43L18 16.572 16.569 18zm4.293-5.73l2.86-2.86a10.119 10.119 0 0 0-14.3-.02 11.168 11.168 0 0 1 11.44 2.88zm-11.47-2.85a10.119 10.119 0 0 0 .02 14.3l2.86-2.86a11.168 11.168 0 0 1-2.88-11.44zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z" fill-rule="evenodd"/>'
  }
})
